export default __webpack_public_path__ + "static/media/CIRCULAR RAIDER.50a3a063.pdf";